import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@ipc/ipc-core';
import { getLanguageFromURL } from '../../../../core/modules/common/tools/Internationalization';

const TranslatedLink = (props) => {
  const toLink =
    (typeof props.to === 'string' && props.to.startsWith('/'))
      ? `/${getLanguageFromURL()}${props.to}` : props.to;

  return (
    <Link {...props} path={toLink}>
      {props.children}
    </Link>);
};
export default TranslatedLink;

TranslatedLink.propTypes = {
  to: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.element,
  ]),
};
